// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleNotes-module__headerRow___DxsC6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 20px;
}

.HuddleNotes-module__header___YVvAB {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #71717a;
}

.HuddleNotes-module__headerMeta___Yio5h {
  font-size: 13px;
  color: #a1a1aa;
}

.HuddleNotes-module__threadRow___GxyGB {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 20px;
  background: #fafafa;
}

.HuddleNotes-module__note___oUU07 {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.HuddleNotes-module__avatar___A6FHQ {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  font-weight: 600;
  color: #ffffff;
}

.HuddleNotes-module__noteBody___NNHW1 {
  min-width: 0;
  flex: 1;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.HuddleNotes-module__noteText___qV_VX {
  font-size: 13px;
  color: #18181b;
  white-space: pre-wrap;
}

.HuddleNotes-module__noteMeta___P9Eg1 {
  margin-top: 4px;
  font-size: 12px;
  color: #a1a1aa;
}

.HuddleNotes-module__composerRow____eLhR {
  padding: 16px 20px;
}

.HuddleNotes-module__composer___NG_YT {
  width: 100%;
  min-height: 60px;
  padding: 8px 10px;
  font-size: 13px;
  font-family: inherit;
  color: #18181b;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  resize: vertical;
}

.HuddleNotes-module__composerButtons___wgWd4 {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.HuddleNotes-module__postButton___rXixw {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #18181b;
  cursor: pointer;
}

.HuddleNotes-module__postButton___rXixw:hover:not(:disabled) {
  background: #f4f4f5;
}

.HuddleNotes-module__postButton___rXixw:disabled {
  color: #a1a1aa;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/HuddleNotes/HuddleNotes.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,OAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF","sourcesContent":[".headerRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 16px 20px;\n}\n\n.header {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #71717a;\n}\n\n.headerMeta {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.threadRow {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px 20px;\n  background: #fafafa;\n}\n\n.note {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 10px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.noteBody {\n  min-width: 0;\n  flex: 1;\n  padding: 8px 12px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.noteText {\n  font-size: 13px;\n  color: #18181b;\n  white-space: pre-wrap;\n}\n\n.noteMeta {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.composerRow {\n  padding: 16px 20px;\n}\n\n.composer {\n  width: 100%;\n  min-height: 60px;\n  padding: 8px 10px;\n  font-size: 13px;\n  font-family: inherit;\n  color: #18181b;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  background: #ffffff;\n  resize: vertical;\n}\n\n.composerButtons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.postButton {\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #18181b;\n  cursor: pointer;\n}\n\n.postButton:hover:not(:disabled) {\n  background: #f4f4f5;\n}\n\n.postButton:disabled {\n  color: #a1a1aa;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `HuddleNotes-module__headerRow___DxsC6`,
	"header": `HuddleNotes-module__header___YVvAB`,
	"headerMeta": `HuddleNotes-module__headerMeta___Yio5h`,
	"threadRow": `HuddleNotes-module__threadRow___GxyGB`,
	"note": `HuddleNotes-module__note___oUU07`,
	"avatar": `HuddleNotes-module__avatar___A6FHQ`,
	"noteBody": `HuddleNotes-module__noteBody___NNHW1`,
	"noteText": `HuddleNotes-module__noteText___qV_VX`,
	"noteMeta": `HuddleNotes-module__noteMeta___P9Eg1`,
	"composerRow": `HuddleNotes-module__composerRow____eLhR`,
	"composer": `HuddleNotes-module__composer___NG_YT`,
	"composerButtons": `HuddleNotes-module__composerButtons___wgWd4`,
	"postButton": `HuddleNotes-module__postButton___rXixw`
};
module.exports = ___CSS_LOADER_EXPORT___;
